import React from 'react';
import styled from 'styled-components'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    LineController,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    LineController,
    Title,
    Tooltip,
    Legend
);

function findLargestValue(chartData) {
    let maxVal = -Infinity;

    for (let dataset of chartData.datasets) {
        for (let value of dataset.data) {
            if (value !== null && value > maxVal) {
                maxVal = value;
            }
        }
    }

    return maxVal;
}

function findMaxStackedValue(chartData) {
    let maxStackedValue = -Infinity;
    if (!chartData || !chartData.datasets || chartData.datasets.length === 0) return 0;

    // Determine number of points from the first bar dataset or fallback to first dataset
    const barDatasets = chartData.datasets.filter(ds => !!ds.stageKey);
    const dataLength = (barDatasets[0]?.data?.length) || (chartData.datasets[0]?.data?.length) || 0;

    for (let i = 0; i < dataLength; i++) {
        let sum = 0;
        barDatasets.forEach(ds => {
            const value = ds.data[i];
            sum += value !== null ? value : 0;
        });
        if (sum > maxStackedValue) {
            maxStackedValue = sum;
        }
    }

    return maxStackedValue;
}

function roundToNearestTwentyThousand(number) {
    return Math.round(number / 20000) * 20000;
}



const Shimmer = styled.div`
    width: 100%;
    height: 340px;
    border-radius: 8px;
    background: linear-gradient(90deg, #eef1f5 25%, #f5f7fa 37%, #eef1f5 63%);
    background-size: 400% 100%;
    animation: shimmer 1.2s ease-in-out infinite;
    @keyframes shimmer {
        0% { background-position: 100% 0; }
        100% { background-position: 0 0; }
    }
`;

const StackedBarChart = ({ data, onSegmentClick, loading }) => {
    const isLoading = loading || !data;
    const maxSingleVal = isLoading ? 0 : findLargestValue(data);
    const maxStackedVal = isLoading ? 0 : findMaxStackedValue(data);
    const maxVal = isLoading ? 0 : roundToNearestTwentyThousand(Math.max(maxSingleVal, maxStackedVal) + 20000);

    
    return (
    <Container>
        <Box>
        {isLoading ? (
            <Shimmer />
        ) : (
		    <Bar
                data={data}
                options={{
                    responsive: true,
                    scales: {
                        x: {
                            stacked: true,
                        },
                        y: {
                            stacked: true,
                            beginAtZero: true,
                            max: maxVal,
                        },
                        line1: {
                            display: false,
                            position: 'right',
                            beginAtZero: true,
                            max: maxVal
                        },
                    },
                    plugins: {
                        legend: {
                            position: 'bottom',
                        },
                        title: {
                            display: false,
                            text: 'Sales',
                        },
					},
                    onHover: (evt, elements, chart) => {
                        const canvas = chart?.canvas;
                        if (!canvas) return;
                        if (elements && elements.length > 0) {
                            const ds = chart.data.datasets[elements[0].datasetIndex];
                            canvas.style.cursor = ds && ds.stageKey ? 'pointer' : 'default';
                        } else {
                            canvas.style.cursor = 'default';
                        }
                    },
					onClick: (evt, elements, chart) => {
						if (!elements || elements.length === 0) return;
						const first = elements[0];
						const dataIndex = first.index;
						const ds = chart.data.datasets[first.datasetIndex];
						if (!ds || !ds.stageKey) return;
						const month = chart.data.labels[dataIndex];
						const stageKey = ds.stageKey;
						const stageLabel = ds.label;
						if (onSegmentClick) onSegmentClick({ month, stageKey, stageLabel });
					}
                }}
		    />
        )}
        </Box>
    </Container>
)};

export default StackedBarChart;

const Container = styled.div`
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
    border-radius: 12px;
    background-color: #fff;
    margin-top: 40px;
`;

const Box = styled.div`
    padding: 20px;
    min-height: 580px;
`;

// import React from 'react';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     LineElement,   // Import LineElement for the line chart
//     PointElement,  // Import PointElement for the points on the line chart
//     LineController,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import { Bar } from 'react-chartjs-2';

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     LineElement,   // Register LineElement
//     PointElement,  // Register PointElement
//     LineController,
//     Title,
//     Tooltip,
//     Legend
// );

// const StackedBarChart = ({ data }) => (
//     <Bar
//         data={data}
//         options={{
//             responsive: true,
//             scales: {
//                 x: {
//                     stacked: true,
//                 },
//                 y: {
//                     stacked: true,
//                 },
//             },
//             plugins: {
//                 legend: {
//                     position: 'bottom',
//                 },
//                 title: {
//                     display: false,
//                     text: 'Sales',
//                 },
               
//             },
//         }}
//     />
// );

// export default StackedBarChart;